import React from "react";
import Card from "../common/Card";

const Services = () => {
  return (
    <div className="services__cards" id="hizmetler">
      <Card
        header="İmplant ve Gömük Diş Cerrahisi"
        icon="https://res.cloudinary.com/dydyt6wbt/image/upload/v1536370626/batuhan/implant.svg"
        description="Eksik dişler dental implantlar ile ağızdaki sağlıklı dişlere zarar vermeden yerine konabilir. 20 yaş dişleri ve gömük dişler ameliyat ile çekilmektedir."
        alttext="İmplant ve Gömük Diş Cerrahisi"
      />
      <Card
        header="Botoks"
        icon="https://res.cloudinary.com/dydyt6wbt/image/upload/v1536369666/batuhan/botoks.svg"
        description="Bruksizm (diş sıkma) tedavisinde botox ile etkili ve kısa sürede başarılı sonuçlar alınmaktadır."
        alttext="Botoks"
      />
      <Card
        header="Panoramik Röntgen"
        icon="https://res.cloudinary.com/dydyt6wbt/image/upload/v1536369664/batuhan/rontgen.svg"
        description="Sirona Orthophos 2d cihazımız ile çenedeki ve dişlerdeki rahatsızlıkların tek bir film ile muayenesi yapılmaktadır."
        alttext="Panoramik Röntgen"
      />
      <Card
        header="Diş Beyazlatma"
        icon="https://res.cloudinary.com/dydyt6wbt/image/upload/v1536370623/batuhan/beyazlatma.svg"
        description="lazer cihazımız ile diş renginde kontrollü beyazlatmalar yaparak daha estetik bir gülüş kazandırılmaktadır."
        alttext="Diş Beyazlatma"
      />
      <Card
        header="Pedodonti"
        icon="https://res.cloudinary.com/dydyt6wbt/image/upload/v1537728451/batuhan/baby.svg"
        description="Çocuk hastalarımızın dental problemleri eğlenceli ve huzurlu bir şekilde tedavi edilmekte ve diş hekimi korkularını yenmelerine yardımcı olunmaktadır."
        alttext="Pedodonti"
      />
      <Card
        header="Ortodonti"
        icon="https://res.cloudinary.com/dydyt6wbt/image/upload/v1537728451/batuhan/braces.svg"
        description="Diş capraşıklıkları, sürmeyen dişler, dişler arasındaki boşlukları (diastemalar) diş telleri yardımı ile tedavi edilmektedir."
        alttext="Ortodonti"
      />
      <Card
        header="Kanal Tedavisi"
        icon="https://res.cloudinary.com/dydyt6wbt/image/upload/v1537728451/batuhan/139405.svg"
        description="Vdw gold cihazımız ile derin çürüklü dişler daha kısa sürede tedavi edilmektedir."
        alttext="Kanal Tedavisi"
      />
      <Card
        header="Protez"
        icon="https://res.cloudinary.com/dydyt6wbt/image/upload/v1537728451/batuhan/dental.svg"
        description="Diş eksikliğinin ve harap dişlerin tedavisinde porselen ve zirkonyum kuron-köprüler kullanılmaktadır. Hastalarımızın ihtiyacına göre total ve parsiyel protezler tercih edilmektedir."
        alttext="Protez"
      />
    </div>
  );
};

export default Services;



// WEBPACK FOOTER //
// ./src/components/main/Services.js